import * as React from "react";
import Grid from "@mui/material/Grid";
import { CustomPaper } from "../Components/CustomPaper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import DesignConsiderations from "./DesignConsiderations";
import AbbreviationsList from "./AbbreviationsList";
import SafetyInfo from "./SafetyInfo";
import { ABOUT_TAB_ROUTES, ROUTES } from "../Util/RouteConstants";
import FullAppOverview from "./FullAppOverview";

const classes = {
  root: {
    // position: "relative",
    // height: "calc(100% - 84px)",
    height: "100%",
    maxWidth: "1200px",
    // display: 'flex',
    margin: "10px auto",
    padding: "20px",
    textAlign: "left",
    overflow: "auto",
  },
  tabRoot: {
    height: "calc(100% - 84px)",
    overflow: "auto",
  },
  title: {
    textAlign: "center",
  },
  subHeader: {
    paddingLeft: "20px",
    fontWeight: "bold",
    marginTop: "15px",
  },
  bodyText: {
    paddingLeft: "20px",
    paddingRight: "20px",
    fontSize: "11pt",
  },
  tabbed: {
    paddingLeft: "50px",
  },
  doubleTabbed: {
    paddingLeft: "100px",
  },
  pedListHeader: {
    marginTop: "10px",
    fontWeight: "bold",
    marginLeft: "15px",
    paddingLeft: "5px",
    borderBottom: "1px solid black",
    width: "400px",
    fontSize: "11pt",
  },
  pedList: { fontSize: "11pt", marginTop: 0 },
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

export default function About() {
  const navigate = useNavigate();
  const [scrollToTopVisible, setScrollToTopVisible] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(0);

  const scrollDiv = React.useRef(null);

  const handleChange = (event, newTabValue) => {
    const TAB_NUMBER_TO_ROUTE = [
      ROUTES.TOOL_OVERVIEW,
      ROUTES.ABBREVIATIONS,
      ROUTES.SAFETY_INFORMATION,
      ROUTES.DESIGN_CONSIDERATIONS,
    ];
    navigate(TAB_NUMBER_TO_ROUTE[newTabValue]?.route);
  };

  const toggleVisible = (evt) => {
    const scrolled = evt.target.scrollTop;
    if (scrolled > 300) {
      setScrollToTopVisible(true);
    } else if (scrolled <= 300) {
      setScrollToTopVisible(false);
    }
  };

  const scrollToTop = () => {
    // console.log("called")
    // console.log(scrollDiv.current);
    // console.log(scrollDiv.current.scrollTo);
    // scrollDiv.current.
    scrollDiv.current.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  // window.addEventListener('scroll', toggleVisible);

  const location = useLocation();
  React.useEffect(() => {
    const locTokens = location.pathname.split("/");
    const toTabName = locTokens[locTokens.length - 1];
    if (toTabName === ABOUT_TAB_ROUTES.TOOL_OVERVIEW) {
      setTabValue(0);
    } else if (toTabName === ABOUT_TAB_ROUTES.ABBREVIATIONS) {
      setTabValue(1);
    } else if (toTabName === ABOUT_TAB_ROUTES.SAFETY_INFORMATION) {
      setTabValue(2);
    } else if (toTabName === ABOUT_TAB_ROUTES.DESIGN_CONSIDERATIONS) {
      setTabValue(3);
    }
  }, [location.pathname]);
  return (
    <div style={{ height: "calc(100% - 84px)", position: "relative" }}>
      <CustomPaper sx={classes.root} onScroll={toggleVisible} ref={scrollDiv}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Tabs
              value={tabValue}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Overview of the Tool" {...a11yProps(0)} />
              <Tab label="List of Abbreviations" {...a11yProps(1)} />
              <Tab label="Safety Information" {...a11yProps(2)} />
              <Tab label="Design Considerations" {...a11yProps(3)} />
            </Tabs>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <TabPanel value={tabValue} index={0}>
                  <FullAppOverview classes={classes} />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                  <AbbreviationsList />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                  <SafetyInfo />
                </TabPanel>
                <TabPanel value={tabValue} index={3}>
                  <DesignConsiderations />
                </TabPanel>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CustomPaper>
      <div
        style={{
          display: scrollToTopVisible ? "block" : "none",
          position: "absolute",
          bottom: "5px",
          width: "100%",
          maxWidth: "1200px",
          // margin: "auto",
          left: "50%",
          WebkitTransform: "translateX(-50%)",
          transform: "translateX(-50%)",
          // backgroundColor: "lightcyan"
        }}
      >
        {scrollToTopVisible && (
          <Tooltip title={"Back to Top"} placement="top" arrow>
            {/*<IconButton aria-label={"back to top"} sx={{float: "right", marginRight: "20px", color: VDOTColorHelper.VDOT_Orange}}>*/}
            {/*    <FontAwesomeIcon icon="fa-solid fa-chevrons-up" />*/}
            {/*</IconButton>*/}
            <Button
              variant="contained"
              color="secondary"
              sx={{
                float: "right",
                marginRight: "20px",
                color: "white",
                opacity: "75%",
                "&:hover": { opacity: "100%" },
              }}
              startIcon={<FontAwesomeIcon icon="fa-solid fa-chevrons-up" />}
              onClick={scrollToTop}
              disableElevation
            >
              Top
            </Button>
          </Tooltip>
        )}
      </div>
    </div>
  );
}
